import { ListedInstrument, ListedInstrumentLike } from '../instrument/listedInstrument';

export enum InstrumentSubscriptionDataScope {
  // Trades = 't',
  MarketData = 'md',
  // MarketDataExtra = 'mde',
  // Book1 = 'mdh1',
  // Book5 = 'mdh5',
  Book10 = 'mdh10',
  // Book20 = 'mdh20',
  // OHLCV = 'ohlcv',
  Fundamentals = 'fun',
  // Financials = 'fin',
}

export type InstrumentSubscriptionMap = {
  ric: string;
  mic: string;
  source: Record<string, Array<InstrumentSubscriptionDataScope>>;
};

export type InstrumentSubscriptionRequestItem = {
  ric: string;
  mic: string;
  rt: boolean;
  datascopes: Array<InstrumentSubscriptionDataScope>;
};

export type SubscribeOptions = {
  instrument: ListedInstrument | ListedInstrumentLike;
  source: string;
  dataScope: Array<InstrumentSubscriptionDataScope>;
  forceRequestStaticData?: boolean;
};

export type SubscribeList = {
  instruments: Array<ListedInstrument | ListedInstrumentLike>;
  source: string;
  dataScope: Array<InstrumentSubscriptionDataScope>;
  forceRequestStaticData?: boolean;
};
